import { useState } from 'react';
import { Add, InsertDriveFileOutlined, Remove } from '@material-ui/icons';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Paper from '@material-ui/core/Paper';
import { DesignFileSearchResult } from '../../api-client/autogenerated';
import { Collapse } from '@material-ui/core';
import { ascendingComparator } from '../document-index/DocumentIndexUtils';
import DesignFileSearchItem from './DesignFileSearchItem';

interface DesignFileSearchResultsProps {
  files: DesignFileSearchResult[];
  searchTerm: string;
  keywordSearchTerms: string[];
}

export default function DesignFileSearchResults(props: DesignFileSearchResultsProps) {
  const { files, searchTerm, keywordSearchTerms } = props;

  const [open, setOpen] = useState(true);

  return (
    <Paper
      style={{
        marginBottom: 8,
        boxShadow: '1px 1px 10px 1px rgba(0, 0, 0, 0.1)',
      }}
    >
      <div
        onClick={() => setOpen((prev) => !prev)}
        style={{
          display: 'flex',
          position: 'relative',
          alignItems: 'center',
          padding: 16,
          borderBottom: '1px solid #DCDCDC',
          cursor: 'pointer',
          zIndex: 10,
        }}
      >
        <InsertDriveFileOutlined
          htmlColor="#0247B9"
          style={{ fontSize: 26, marginRight: 9, marginLeft: -2 }}
        />
        <Typography style={{ fontSize: '18px', lineHeight: '24px', fontWeight: 700 }}>
          CENTERLINE Drive ({files.length})
        </Typography>
        <div style={{ display: 'inline-flex', flexGrow: 100 }} />
        <IconButton style={{ padding: 0 }}>{open ? <Remove /> : <Add />}</IconButton>
      </div>
      <Collapse in={open}>
        {files
          .sort((a, b) => ascendingComparator(a, b, 'key'))
          .map((file) => (
            <DesignFileSearchItem
              key={file.id}
              designFile={file}
              searchTerm={searchTerm}
              keywordSearchTerms={keywordSearchTerms}
            />
          ))}
      </Collapse>
    </Paper>
  );
}
